import type { Dispatch } from '@atlaskit/editor-common/event-dispatcher';
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export type ThinkingStatus = 'idle' | 'thinking' | 'complete';

export type ThinkingPluginState = {
	status: ThinkingStatus;
};

export type ThinkingPluginMeta = {
	status: ThinkingStatus;
};

export const thinkingPluginKey: PluginKey<ThinkingPluginState> = new PluginKey<ThinkingPluginState>(
	'aiSuggestionsThinkingPlugin',
);

export function createThinkingPlugin({
	dispatch,
}: {
	dispatch: Dispatch;
}): SafePlugin<ThinkingPluginState> {
	return new SafePlugin<ThinkingPluginState>({
		key: thinkingPluginKey,
		state: {
			init(): ThinkingPluginState {
				return {
					status: 'idle',
				};
			},
			apply(tr, pluginState): ThinkingPluginState {
				const meta: ThinkingPluginMeta | undefined = tr.getMeta(thinkingPluginKey);

				if (meta && meta.status !== pluginState.status) {
					const result: ThinkingPluginState = {
						status: meta.status,
					};
					dispatch(thinkingPluginKey, result);
					return result;
				}

				return pluginState;
			},
		},
	});
}
